import { AnnouncementBar, JaaGaDetails } from "./components";
import ProductSearchHero from "./components/ProductSearchHero";
import HomeSection from "./components/HomeSection";
import { HOME_SECTIONS } from "./homeSections";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import "./HomePage.theme.css";

// The previous home page, kept for phones: the new Mist Blue home is the
// desktop design only (see HomePage.jsx).
const LegacyHome = () => {
  useScrollReveal(".jaaga-home");
  return (
    <main className="jaaga-home" id="main-content">
      <AnnouncementBar />
      <ProductSearchHero />
      <JaaGaDetails />
      {HOME_SECTIONS.map((section) => (
        <HomeSection key={section.key} section={section} />
      ))}
    </main>
  );
};

export default LegacyHome;
